import { ratesByState } from '@/app/(marketplace)/quote-builder/electricity-rates/rates';

import { PROJECTION_YEARS } from '../data/content';

// The teaser names the horizon before a state is picked, so it cannot use
// todayYear(stateCode). Guarded by horizonYear.test.ts: every state's rate
// series ends on the same year, so one constant stands in for all of them.
const latestRateYear = Math.max(...Object.values(ratesByState).map(({ rates }) => rates[rates.length - 1]?.year ?? 0));

export const HORIZON_YEAR = latestRateYear + 1 + PROJECTION_YEARS;
